<div class="row">
  <div class="col-1">
    <app-back-button></app-back-button>
  </div>
  <div class="col">
    <h2 class="h2-responsive text-center">{{scale.name}}</h2>
  </div>
</div>
<div class="row" *ngIf="hasLoaded">
  <mdb-tabset #staticTabs [buttonClass]="'col nav-tabs tabs-3 primary-color'" [contentClass]="'card'" class="col-12">
    <mdb-tab heading="General">
      <form *ngIf="scale">
        <div class="form-group">
          <label for="name">Name:</label>
          <input class="form-control" type="text" id="name" name="name" [(ngModel)]="scale.name" />
        </div>
        <div class="form-group">
          <label for="name">Client Description:</label>
          <input class="form-control" type="text" id="descriptionClient" name="descriptionClient" [(ngModel)]="scale.descriptionClient"
          />
        </div>
        <div class="form-group">
          <label for="name">Therapist Description:</label>
          <input class="form-control" type="text" id="descriptionTherapist" name="descriptionTherapist" [(ngModel)]="scale.descriptionTherapist"
          />
        </div>
        <div class="form-group">
          <label for="multiplier">Multiplier:</label>
          <input class="form-control" type="number" id="multiplier" name="multiplier" [(ngModel)]="scale.multiplier" />
        </div>
        <div class="form-group">
          <input class="form-control" type="checkbox" id="negToPositive" name="negToPositive" [(ngModel)]="scale.negativeToPositiveRanges"
          />
          <label for="negToPositive">Negative to Positive Ranges:</label>
        </div>
        <div class="form-group">
            <input class="form-control" type="checkbox" id="includeInReports" name="includeInReports" [(ngModel)]="scale.includeInReports"
            />
            <label for="includeInReports">Include in reports:</label>
        </div>
        <div class="form-group" *ngIf="scale.hasSubScales()">
            <input class="form-control" type="checkbox" id="rollUpSubScales" name="rollUpSubScales" [(ngModel)]="scale.rollUpSubScales" />
            <label for="rollUpSubScales">Rollup subscale questions into this scale:</label>
        </div>
        <div class="form-group">
          <label for="type">Type</label>
          <select id="scale" class="browser-default form-control" name="type" [ngModel]="scale.type" (ngModelChange)="updateType($event)">
            <option *ngFor="let type of ScaleTypes" [ngValue]="type">{{type}}</option>
          </select>
          {{scale.type}}
        </div>
        <div class="form-group" *ngIf="scale.type == 'CriteriaThreshold'">
            <label for="type">Threshold Required Number of Questions</label>
            <input class="form-control" type="number" id="requiredQuestions" name="requiredQuestions" [(ngModel)]="scale.gradingData.requiredQuestions" />
        </div>
        <div class="form-group" *ngIf="scale.type == 'CriteriaThreshold'">
            <label for="type">Threshold Criteria Score of Questions</label>
            <input class="form-control" type="number" id="requiredScoreThreshold" name="requiredScoreThreshold" [(ngModel)]="scale.gradingData.requiredScoreThreshold" />
        </div>
        <input type="button" (click)="save()" class="btn btn-primary" value="Save" />
        <input type="button" (click)="saveAndCreateNew()" class="btn btn-primary" value="Save and Create New" />
      </form>
    </mdb-tab>
    <mdb-tab heading="Ranges">
      <h2>Scale Ranges</h2>
      <a [routerLink]="['scale-range','new']" type="button" class="btn btn-primary">New Range</a>
      <p class="alert alert-info" *ngIf="!scale.ranges.length">No Ranges exist.</p>
      <table class="table table-striped" *ngIf="scale.ranges.length">
        <thead>
          <tr>
            <th *ngFor="let name of ['Display Name', 'Range', 'Therapist Content', 'Client Content', 'Actions']">{{name}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let range of scale.ranges">
            <td>{{range.displayName}}</td>
            <td>{{range.rangeStart}} - {{range.rangeEnd}}</td>
            <td class="w-25">
              <div [innerHTML]="range.therapistContent"></div>
            </td>
            <td class="w-25">
              <div [innerHTML]="range.clientContent"></div>
            </td>
            <td class="w-25">
              <button [routerLink]="['scale-range',range.id, 'edit']" type="button" class="btn btn-primary btn-sm" aria-label="Edit">
                <span class="fa fa-edit" aria-hidden="true"></span>
              </button>
              <button (click)="deleteRange(range)" type="button" class="btn btn-secondary btn-sm" aria-label="Delete">
                <span class="fa fa-trash" aria-hidden="true"></span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </mdb-tab>
    <mdb-tab heading="Sub Scales">
      <h2>Sub Scales</h2>
      <form>
        <div class="form-group">
          <h2 class="h2-responsive">Possible Subscales</h2>
          <div *ngFor="let subscale of AvailableSubScales">
            <input [id]="subscale.id" class="form-control" type="checkbox" (click)="toggleSubScale(subscale)" [checked]="isSelected(subscale)"
              [disabled]="!subscale.available" />
            <label [for]="subscale.id" (click)="toggleSubScale(subscale)">{{subscale.name}}</label>
          </div>
        </div>
        <input type="button" (click)="save()" class="btn btn-primary" value="Save" />
        <input type="button" (click)="saveAndCreateNew()" class="btn btn-primary" value="Save and Create New" />
      </form>
    </mdb-tab>
  </mdb-tabset>
</div>


// WEBPACK FOOTER //
// ./src/app/admin/scale-edit/scale-edit.component.html